import { TextKey } from '@mews-commander/enums';
import { IconName } from '@optimus-web/icons';
import { useAppConfiguration } from '@mews-commander/data-access';
import { Icon } from '@optimus-web/core';
import { createListItem } from '../helpers';
import StyledSidebarLink from '../StyledSidebarLink';

const atomizeMenuItemElement = createListItem({
    textKey: TextKey.AtomizeRmsMenuItem,
    iconName: IconName.RateManagement,
    isMainItem: true,
    rightItem: <Icon size="small" value={IconName.ExternalLink} />,
});

export const AtomizeMenuItem = () => {
    const serverUrl = useAppConfiguration().currentServerUrl;
    return (
        <StyledSidebarLink href={`${serverUrl}/rms`} target="_blank">
            {atomizeMenuItemElement}
        </StyledSidebarLink>
    );
};
